<div class="intersection-view-container container" fxLayout="row" fxLayoutGap="3px">
  <span *ngIf="quadrantDefinition">{{quadrantDefinition.displayName}} of</span>
  <span>{{location.intersectionStreet1}} & {{location.intersectionStreet2}}</span>
</div>
